import audienceMixin from '../Mixins/audiences-table';
import Channels from './Channels/channels.vue';
import {BuilderTabIds,RouteNames} from "@modules/AudienceManager/constants";

import {createNamespacedHelpers} from 'vuex';
const {mapState} = createNamespacedHelpers('audienceManager/overview');

export default {
    name: 'overview-published',
    components: {
        Channels
    },
    mixins: [audienceMixin],
    methods: {
        async navigateToOverview(id){
            await this.$router.push({
                name: RouteNames.BUILDER_OVERVIEW_TAB, 
                params: { audienceId: id, tabId: BuilderTabIds.OVERVIEW }
            });
        }
    },
    computed: {
        plusBtn() {
            return `
                <span class="custom-button" name="add-channels" data-toggle="tooltip"
                    title="${this.resource('AudienceManager_Overview_Published_AddRemove_Channels_Tooltip')}"
                >
                    <a href="javascript:void(0)" class="mdb-icon-btn">
                        <i class="fas fa-plus"></i>
                    </a>
                </span>`;
        },
        overviewBtn() {
            return `
                <span class="custom-button" name="overview" data-toggle="tooltip"
                    title="${this.resource('AudienceManager_Overview_Published_GoToOverView_Tooltip')}"
                >
                    <a href="javascript:void(0)" class="mdb-icon-btn">
                        <i class="fas fa-sign-out-alt"></i>
                    </a>
                </span>`;
        },
        publishedAudiences() {
            const vm = this;
            return Object.values(vm.audiences).filter((audience) => audience.status === vm.status.published);
        },
        allColumns() {  
            return [
                ...this.columns, {
                    defaultContent: this.plusBtn,
                    sortable: false
                },{ 
                    title: this.resource('AudienceManager_OverView_Published_Action'),
                    defaultContent: this.overviewBtn, 
                    sortable: false
                }
            ];
        }, 
        ...mapState(['audiences','loadingAudiences'])
    },
    data() {
        return {
            selectedId: null
        };
    }
};